﻿import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormSelect, FormNumericInput } from "components/form-fields";

export function FrequencyInput(
    {
        frequencySelectedValue = 0,
        min = 0,
        max = 99999,
        className,
        disabled,
        frequencyTypeDangerHelperText,
        frequencyTypeSelectedValue,
        loading,
        onFrequencyChange,
        onFrequencyTypeChange
    }
) {
    const reoccurrenceRepeatOptions = [
        { name: "Days", id: "D", daysBetweenChecks: 1 },
        { name: "Weeks", id: "W", daysBetweenChecks: 7 },
        { name: "Months", id: "M", daysBetweenChecks: 30.4 },
    ]

    return (
        <div className={classNames("inline-items", className)}>
            <div className="inline-item">
                <FormNumericInput
                    loading={loading}
                    disabled={disabled}
                    disabledInput={disabled}
                    min={min}
                    max={max}
                    selectedValue={frequencySelectedValue}
                    onValueChange={onFrequencyChange}
                ></FormNumericInput>
            </div>
            <div className="inline-item">
                <FormSelect
                    loading={loading}
                    disabled={disabled}
                    items={reoccurrenceRepeatOptions}
                    selectedValue={frequencyTypeSelectedValue}
                    onItemSelect={onFrequencyTypeChange}
                    dangerHelperText={frequencyTypeDangerHelperText}
                    placeholder="Select one"
                    small
                ></FormSelect>
            </div>
        </div>
    );
}

FrequencyInput.propTypes = {
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    frequencySelectedValue: PropTypes.number,
    frequencyTypeSelectedValue: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    onFrequencyChange: PropTypes.func,
    onFrequencyTypeChange: PropTypes.func,
    frequencyTypeDangerHelperText: PropTypes.string,
    className: PropTypes.string
};